import { createAsyncThunk } from "@reduxjs/toolkit";
import { FetchRequestHandler } from "../../utils/commonUtilities";
import { baseUrl } from "../../constants/Endpoints/EndPoints";

export const fetchProviderPhotosList = createAsyncThunk(
  "fetchProviderPhotosList",
  async (providerId) => {
    const result = await FetchRequestHandler(
      "get",
      `${baseUrl}api/providers/${providerId}/photos?filter=non-profile`
    );
    // console.log({result});
    return result;
  }
);

export const fetchProviderProfilePhoto = createAsyncThunk(
  "fetchProviderProfilePhoto",
  async (providerId) => {
    const result = await FetchRequestHandler(
      "get",
      `${baseUrl}api/providers/${providerId}/photos?filter=profile`
    );
    return result;
  }
);

export const fetchAddProviderPhotos = createAsyncThunk(
  "fetchAddProviderPhotos",
  async ({ providerId, data }) => {
    console.log("actions : ", providerId, data);

    const result = await FetchRequestHandler(
      "post",
      `${baseUrl}api/providers/${providerId}/photos`,
      data
    );
    return result;
  }
);

export const fetchDeleteProviderPhotos = createAsyncThunk(
  "fetchDeleteProviderPhotos",
  async ({ providerId, imageId }) => {
    console.log(providerId, imageId);

    const result = await FetchRequestHandler(
      "delete",
      `${baseUrl}api/providers/${providerId}/photos/${imageId}`
    );
    return result;
  }
);
